<template>
  <div class="solution-content">
    <div class="common-title">
      <div class="common-title-content">
        方案概述
      </div>
    </div>
    <p class="solution-info">
      集成物联网、大数据、云计算等先进技术，打造开放型、前瞻性的综合性社会治理系统，推动资源整合、信息共享，有效对接政务管理服务与群众核心诉求，保证和维持治理成效、机制改革成果，实现社会治理高效率。
    </p>
    <div class="solution-des">
      <img src="@/assets/images/solution/img_syzl.png" />
    </div>
    <div class="solution-main-function">
      <div class="common-title">
        <div class="common-title-content">
          主要功能
        </div>
      </div>
      <div class="solution-main-show">
        <div class="show-item" v-for="(item, index) in iconList" :key="index">
          <img :src="item.iconSrc" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="solution-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="show-scene-list">
        <div class="item" v-for="(item, index) in imgList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "zhsq",
  data() {
    return {
      iconList: [
        {
          iconSrc: require("@/assets/images/solution/ico_sjlz.png"),
          text: "事件流转"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_wgfw.png"),
          text: "网格服务"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_jdww.png"),
          text: "街道维稳"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_mdcz.png"),
          text: "矛盾处置"
        },
        {
          iconSrc: require("@/assets/images/solution/ico_zhdd.png"),
          text: "指挥调度"
        }
      ],
      imgList: [
        {
          imgUrl: require("@/assets/images/solution/fxfk.png"),
          text: "风险防控"
        },
        {
          imgUrl: require("@/assets/images/solution/dygz.png"),
          text: "多元共治"
        },
        {
          imgUrl: require("@/assets/images/solution/jczc.png"),
          text: "决策支撑"
        },
        {
          imgUrl: require("@/assets/images/solution/djyl.png"),
          text: "党建引领"
        }
      ]
    };
  }
};
</script>
